import { Component, effect, signal } from '@angular/core';
import {
  DisplayMapComponent,
  DisplayMapOptions,
  ExplorationService,
  GeoBBox,
  Obelisk
} from 'quest-atlas-angular-components';
import { rxResource } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'app-generated-artifacts',
  imports: [
    DisplayMapComponent,
    TranslocoDirective
  ],
  templateUrl: './generated-artifacts.component.html',
  styleUrl: './generated-artifacts.component.scss'
})
export class GeneratedArtifactsComponent {
  bbox = signal<GeoBBox>(null);
  generatedObelisks = rxResource({
    params: () => ({
      bbox: this.bbox(),
    }),
    stream: ({params}) => {
      if (!params.bbox) {
        return of([]);
      }

      return this.explorationService.loadObelisks$([], params.bbox, undefined, {generatedOnly: true})
    },
    defaultValue: []
  });

  generatedCount = rxResource({
    stream: () => this.explorationService.countGeneratedObelisks$()
  })

  mapOptions: DisplayMapOptions = {
    zoom: 12,
  }

  constructor(
    private explorationService: ExplorationService,
    private router: Router
  ) {
    effect(() => {
      if (this.mapOptions.obelisks?.length && !this.generatedObelisks.value()?.length) {
        return;
      }

      this.mapOptions = {
        ...this.mapOptions,
        zoom: undefined,
        obelisks: this.generatedObelisks.value()
      };
    });
  }

  goToEditObelisk(obelisk: Obelisk) {
    this.router.navigate(['obelisks-editor', obelisk.uuid]);
  }

  onMapMoveEnd(map: mapboxgl.Map) {
    this.bbox.set({
      sw: map.getBounds().getSouthWest(),
      ne: map.getBounds().getNorthEast()
    })
  }

  onMapZoom(map: mapboxgl.Map) {
    this.bbox.set({
      sw: map.getBounds().getSouthWest(),
      ne: map.getBounds().getNorthEast()
    })
  }
}
